import React, { useEffect, useRef, useState } from "react";

import styles from "./Navbar.module.css";
import { getImageUrl } from "../../utils";
import { IconButton, Menu, MenuItem } from "@mui/material";
import openIcon from "../../assets/nav/menuIcon.png";
import closeIcon from "../../assets/nav/closeIcon.png";
import { Link } from "react-router-dom";
import { useMediaQuery, useTheme } from "@mui/material";
import { projects } from "../../data/projectsData";

export const Navbar = () => {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [menuOpen, setMenuOpen] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  // const translateRef = useRef(null);
  const [isTranslatorUsed, setIsTranslatorUsed] = useState(false);

  useEffect(() => {
    const checkTranslatorUsage = () => {
      const translateElement =
        document.getElementsByClassName("skiptranslate")[0];
      if (translateElement && translateElement.classList.length === 1) {
        const isDisplayed =
          window.getComputedStyle(translateElement).display !== "none";
        setIsTranslatorUsed(isDisplayed);
      }
    };

    // Initial check
    checkTranslatorUsage();

    // Optional: Periodically check if the translator changes dynamically
    const interval = setInterval(checkTranslatorUsage, 1000);

    // Cleanup the interval
    return () => clearInterval(interval);
  }, []);

  return (
    <nav
      style={{
        ...(isTranslatorUsed === true && {
          top: 40,
        }),
      }}
      className={styles.navbar}
    >
      {isMobile ? (
        <div className={styles.navWrapMobile}>
          <div className={styles.navWrapMobile1}>
            <a
              className={styles.title}
              style={{
                ...(isMobile && {
                  fontSize: "25px",
                }),
              }}
              href="/"
            >
              ADARSH INDUSTRIES
            </a>
            <div
              style={{
                ...(isMobile && {
                  padding: 0,
                }),
              }}
              className={styles.menu}
            >
              <img
                className={styles.menuBtn}
                src={menuOpen ? closeIcon : openIcon}
                alt="menu-button"
                onClick={() => setMenuOpen(!menuOpen)}
              />
              <ul
                className={`${styles.menuItems} ${menuOpen && styles.menuOpen}`}
                onClick={() => setMenuOpen(false)}
              >
                <li className={styles.navbarLlistItem}>
                  <a href="/">Home</a>
                </li>
                <li className={styles.navbarLlistItem}>
                  <a href="/about">About Us</a>
                </li>
                {/* <li>
          <a href="/products">Products</a>
        </li> */}
                <li className={styles.navbarLlistItem}>
                  {/* <IconButton
            onClick={handleMenuOpen}
            size="large"
            edge="end"
            color="inherit"
            aria-label="menu"
          > */}
                  <a
                    style={{
                      color: "white",
                    }}
                    onClick={handleMenuOpen}
                  >
                    Products
                  </a>
                  {/* </IconButton> */}
                  <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleMenuClose}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    transformOrigin={{ vertical: "top", horizontal: "right" }}
                  >
                    {/* <MenuItem
              component={Link}
              to="/products/1"
              onClick={handleMenuClose}
            >
              Product 1
            </MenuItem>
            <MenuItem
              component={Link}
              to="/products/2"
              onClick={handleMenuClose}
            >
              Product 2
            </MenuItem> */}
                    {projects.group1.map((project, id) => {
                      return (
                        <MenuItem
                          component={Link}
                          to={"/products/" + project.id}
                          onClick={handleMenuClose}
                        >
                          {project.title}
                        </MenuItem>
                      );
                    })}
                    {projects.group2.map((project, id) => {
                      return (
                        <MenuItem
                          component={Link}
                          to={"/products/" + project.id}
                          onClick={handleMenuClose}
                        >
                          {project.title}
                        </MenuItem>
                      );
                    })}
                    {projects.group3.map((project, id) => {
                      return (
                        <MenuItem
                          component={Link}
                          to={"/products/" + project.id}
                          onClick={handleMenuClose}
                        >
                          {project.title}
                        </MenuItem>
                      );
                    })}

                    {/* Add more MenuItem for additional products */}
                  </Menu>
                </li>
                {/* <li>
          <a href="/gallery">Gallery</a>
        </li> */}
              </ul>
            </div>
          </div>
          <div className={styles.navWrapMobile2}>
            <div
              id="google_translate_element"
              // ref={translateRef}
              className={styles.translateContainer}
            ></div>
          </div>
        </div>
      ) : (
        <div className={styles.navWrap}>
          {" "}
          <a
            className={styles.title}
            style={{
              ...(isMobile && {
                fontSize: "25px",
              }),
            }}
            href="/"
          >
            ADARSH INDUSTRIES
          </a>
          <div
            style={{
              ...(isMobile && {
                padding: 0,
              }),
            }}
            className={styles.menu}
          >
            <img
              className={styles.menuBtn}
              src={menuOpen ? closeIcon : openIcon}
              alt="menu-button"
              onClick={() => setMenuOpen(!menuOpen)}
            />
            <ul
              className={`${styles.menuItems} ${menuOpen && styles.menuOpen}`}
              onClick={() => setMenuOpen(false)}
            >
              <li className={styles.navbarLlistItem}>
                <a href="/">Home</a>
              </li>
              <li className={styles.navbarLlistItem}>
                <a href="/about">About Us</a>
              </li>
              {/* <li>
            <a href="/products">Products</a>
          </li> */}
              <li className={styles.navbarLlistItem}>
                {/* <IconButton
              onClick={handleMenuOpen}
              size="large"
              edge="end"
              color="inherit"
              aria-label="menu"
            > */}
                <a
                  style={{
                    color: "white",
                  }}
                  onClick={handleMenuOpen}
                >
                  Products
                </a>
                {/* </IconButton> */}
                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleMenuClose}
                  anchorOrigin={{ vertical: "top", horizontal: "right" }}
                  transformOrigin={{ vertical: "top", horizontal: "right" }}
                >
                  {/* <MenuItem
                component={Link}
                to="/products/1"
                onClick={handleMenuClose}
              >
                Product 1
              </MenuItem>
              <MenuItem
                component={Link}
                to="/products/2"
                onClick={handleMenuClose}
              >
                Product 2
              </MenuItem> */}
                  {projects.group1.map((project, id) => {
                    return (
                      <MenuItem
                        component={Link}
                        to={"/products/" + project.id}
                        onClick={handleMenuClose}
                      >
                        {project.title}
                      </MenuItem>
                    );
                  })}
                  {projects.group2.map((project, id) => {
                    return (
                      <MenuItem
                        component={Link}
                        to={"/products/" + project.id}
                        onClick={handleMenuClose}
                      >
                        {project.title}
                      </MenuItem>
                    );
                  })}
                  {projects.group3.map((project, id) => {
                    return (
                      <MenuItem
                        component={Link}
                        to={"/products/" + project.id}
                        onClick={handleMenuClose}
                      >
                        {project.title}
                      </MenuItem>
                    );
                  })}

                  {/* Add more MenuItem for additional products */}
                </Menu>
              </li>
              {/* <li>
            <a href="/gallery">Gallery</a>
          </li> */}
            </ul>
          </div>
          <div
            id="google_translate_element"
            // ref={translateRef}
            className={styles.translateContainer}
          ></div>
        </div>
      )}
    </nav>
  );
};
